const init = (root) => {
    root.classList.add('initialized');
    const setMenuStateClass = () => {
        document.documentElement.classList.toggle('is-menu-open', root.checked);
    };
    setMenuStateClass();
    root.addEventListener('input', () => setMenuStateClass());
    const menuElements = document.querySelectorAll('.c-menu__link');
    menuElements.forEach((menuElement) => {
        if (!(menuElement instanceof HTMLAnchorElement) || !menuElement.href.includes('#')) {
            return;
        }
        menuElement.addEventListener('click', () => {
            if (document.documentElement.classList.contains('is-menu-open')) {
                root.checked = false;
                setMenuStateClass();
            }
        });
    });
};
export const initBurger = (root = document) => {
    const burger = root.querySelector('.js-burger:not(.initialized)');
    if (burger) {
        init(burger);
    }
};
